import src from "IMAGE";
export default { src, width: 46, height: 66, blurWidth: 6, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAANElEQVR42p2MwQkAIAwD6zuQFfw5jzqzg0k+/ZXSBg6OBGLWzQAwhdxbkmuf+4Q8H8KrUj6NrQkhXxwUZgAAAABJRU5ErkJggg=="};
